import { ChangeEvent, FC, useEffect } from 'react'
import { RaRecord, ReferenceInput, SelectInput, useGetList } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { ApplicationEnvironmentOut } from '../types/apiRequests'

interface EnvironmentSelectorProps {
  applicationId: string | null | undefined;
  urlField?: string;
}

export const EnvironmentSelector: FC<EnvironmentSelectorProps> = ({ applicationId, urlField }) => {
  const { setValue, getValues } = useFormContext()

  const { data: environments } = useGetList<ApplicationEnvironmentOut>(
    'application_environment',
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: 'display_name', order: 'ASC' },
      // eslint-disable-next-line camelcase
      filter: { application_id: applicationId },
    },
    { enabled: !!applicationId },
  )

  useEffect(() => {
    if (!environments || environments.length !== 1) return
    const env = environments[0]
    setValue('environment_id', env.id, { shouldDirty: true })
    if (urlField && env.base_url && !getValues(urlField)) {
      setValue(urlField, env.base_url, { shouldDirty: true })
    }
  }, [environments, setValue, getValues, urlField])

  if (!applicationId) return null
  if (!environments || environments.length === 0) return null

  return (
    <ReferenceInput
      source="environment_id"
      reference="application_environment"
      // eslint-disable-next-line camelcase
      filter={{ application_id: applicationId }}
    >
      <SelectInput
        optionText="display_name"
        label="data.environment"
        fullWidth
        onChange={(event: ChangeEvent<HTMLInputElement> | RaRecord) => {
          if (!urlField || 'id' in event) return
          const env = environments?.find((e) => e.id === event.target.value)
          if (env?.base_url) setValue(urlField, env.base_url, { shouldDirty: true })
        }}
      />
    </ReferenceInput>
  )
}
